import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../api/api";
import { BASE_URL } from "../../utils/constants";
import { getDepartmentEmoji } from "../../components/Popups";
import "../../style/admin-departments.css";

export default function Departments() {

  const navigate = useNavigate();

  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  // ================= FETCH =================
  const fetchDepartments = async () => {
    try {
      setLoading(true);

      const res = await API.get(`/admin/departments?page=${page}`);

      setDepartments(res.data.data);
      setPages(res.data.pagination.pages);

    } catch (err) {
      console.error("Failed to fetch departments", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, [page]);

  // ================= TOGGLE =================
  const toggleStatus = async (id) => {
    try {
      await API.patch(`/admin/departments/${id}/toggle`);
      fetchDepartments();
    } catch (err) {
      console.error("Toggle failed", err);
    }
  };

  // ================= DELETE =================
  const deleteDept = async (id) => {
    if (!window.confirm("Delete this department?")) return;

    try {
      await API.delete(`/admin/departments/${id}`);
      fetchDepartments();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  return (
    <div className="admin-dept-page">

      {/* ================= HEADER ================= */}
      <div className="admin-dept-header">
        <h1>Departments</h1>

        <button
          className="add-dept-btn"
          onClick={() => navigate("/admin/add-department")}
        >
          + Add Department
        </button>
      </div>

      {/* ================= LOADING ================= */}
      {loading && <p className="loading-text">Loading...</p>}

      {/* ================= EMPTY ================= */}
      {!loading && departments.length === 0 && (
        <p className="empty-text">No departments found</p>
      )}

      {/* ================= TABLE ================= */}
      {!loading && departments.length > 0 && (
        <div className="admin-dept-table">

          <table className="table">
            <thead>
              <tr>
                <th>Icon</th>
                <th>Name</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {departments.map((dept) => (
                <tr key={dept._id}>

                  {/* ICON */}
                  <td>
                    {dept.icon ? (
                      <img
                        src={`${BASE_URL}${dept.icon}`}
                        alt={dept.name}
                        className="dept-icon"
                      />
                    ) : (
                      <span className="dept-placeholder">{getDepartmentEmoji(dept.name)}</span>
                    )}
                  </td>

                  {/* NAME */}
                  <td>{dept.name}</td>

                  {/* STATUS */}
                  <td>
                    <span
                      className={`status-badge ${dept.isActive ? "active" : "inactive"
                        }`}
                    >
                      {dept.isActive ? "Active" : "Inactive"}
                    </span>
                  </td>

                  {/* ACTIONS */}
                  <td className="actions-cell">
                    <div className="actions">
                      <button
                        className="btn-toggle"
                        onClick={() => toggleStatus(dept._id)}
                      >
                        {dept.isActive ? "Disable" : "Enable"}
                      </button>

                      <button
                        className="btn-delete"
                        onClick={() => deleteDept(dept._id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>

        </div>
      )}

      {/* ================= PAGINATION ================= */}
      <div className="pagination">

        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Prev
        </button>

        <span>
          Page {page} of {pages}
        </span>

        <button
          disabled={page === pages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>

      </div>

    </div>
  );
}
